import React, { useEffect } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge } from "@mui/material";
import { fetchOnlyData } from "../../utility/adminApi";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";

function Notification({ toggleNotification, setNotifications }) {
  const navigate = useNavigate();
  const { data: notifications, refetch } = useQuery({
    queryKey: ["notifications"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("notifications"),
    staleTime: 4000,
    // Keep previous data during page changes
  });

  useEffect(() => {
    if (notifications && Array.isArray(notifications)) {
      setNotifications(notifications);
    }
  }, [notifications, setNotifications]);

  if (
    notifications?.status === 401 ||
    notifications?.response?.status === 401
  ) {
    return navigate("/login");
  }

  const totalUnread = Array.isArray(notifications)
    ? notifications.filter((item) => Number(item?.read) === 0).length
    : 0;

  return (
    <>
      <button
        onClick={() => {
          refetch();
          toggleNotification();
        }}
      >
        <Badge color="secondary" badgeContent={totalUnread}>
          <NotificationsIcon className="text" sx={{ fontSize: 40 }} />{" "}
        </Badge>
      </button>
    </>
  );
}

export default Notification;
